import { payxpress_png_logo } from "@/assets";
import { MemoizedAppListItem } from "@/components";
import { payxpressMenuList } from "@/data";
import { MenuNav } from "./Menu";
import { memo } from "react";

const SideBar: React.FC = () => {
  return (
    <aside className="bg-white flex z-10 flex-col w-[300px] max-w-[18rem] md:min-w-[285px] gap-2 shadow-md max-md:hidden">
      <div className="py-2 flex justify-center mt-4">
        <img 
          src={payxpress_png_logo} 
          alt="Logo" 
          className="w-[50%] cursor-pointer" 
          onClick={() => window.location.href = '/home/dashboard'}
        />
      </div>
      <div className="flex flex-col items-end px-4 gap-2 h-[100vh]">
        <MemoizedAppListItem
          items={payxpressMenuList}
          ItemComponent={MenuNav}
        />
      </div>
    </aside>
  );
};

export default memo(SideBar);
